import request from '@/utils/request'

// 查询分类列表
export function productSkuSizeCategoryList(query) {
  return request({
    url: '/power/setting/productSkuSizeCategory/list',
    method: 'get',
    params: query,
  })
}

// 通过一级分类ID查询参数组合的二级分类列表
export function productSkuParamSecondCategoryList(query) {
  return request({
    url: '/power/setting/productSkuParam/secondCategoryList',
    method: 'get',
    params: query,
  })
}

// 通过二级分类ID查询参数组合的三级分类列表
export function productSkuParamThirdCategoryList(query) {
  return request({
    url: '/power/setting/productSkuParam/thirdCategoryList',
    method: 'get',
    params: query,
  })
}

// 查询参数组合列表
export function productSkuParamParamDetailList(query) {
  return request({
    url: '/power/setting/productSkuParam/paramDetailList',
    method: 'get',
    params: query,
  })
}

// 查询尺码分类下拉框
export function productSkuParamSizeTree(query) {
  return request({
    url: '/power/setting/productSkuParam/sizeTree',
    method: 'get',
    params: query,
  })
}
